import HomeBanner from "./home/HomeBanner";
import Services from "./home/Services";
import About from "./home/About";
import Testimonial from "./home/Testimonial";
import HomeBlog from "./home/HomeBlog";
import CaseStudies from "./home/CaseStudies";
import FAQSection from "./home/FAQSection";
import HeroSection from "./home/HeroSection";
import Porfolio from "./home/Porfolio";
import OurClients from "./home/OurClients";
import OurOffering from "./home/OurOffering";
import Products from "./home/Product";
import BoardOfDirectors from "./home/BoardOfDirectors";
import Careers from "./home/Careers";
import PrivacyPolicy from "./home/Careers";
import TermsAndConditions from "./home/Careers";
import SupportSection from "./home/SupportSection";
import WorkProcess from "./home/WorkProcess copy";
import { useEffect, useState } from "react";
import AwardsBanner from "./home/AwardsBanner";

const Home = () => {
  return (
    <div>
      {/* <HeroSection /> */}
      <HomeBanner />
      <About />
      <OurClients />
      <WorkProcess />
      <Services />
      <HomeBlog />
      <Testimonial />
      <FAQSection />
      {/* <SupportSection /> */}
      {/* <OurOffering /> */}
      {/* <AwardsBanner /> */}
      {/* <Products /> */}
      {/* <BoardOfDirectors /> */}
      {/* <Porfolio />/ */}
      {/* <CaseStudies /> */}
      {/* <Careers /> */}
    </div>
  );
};

export default Home;
